import React, { Component } from 'react';
import AlertBox, { Heading, SubHeading } from 'components/shared/AlertBox';
import { ButtonGroup, Button, TypeToConfirm } from 'ui';
import LinkButton from 'components/shared/LinkButton';

class ConfirmationModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmed: false,
    };
  }

  handleConfirmation = text => {
    const { roleName } = this.props;
    this.setState({ confirmed: text === roleName });
    return text === roleName;
  };

  render() {
    const {
      onDismiss,
      permissionsToGrant,
      onSubmit,
      roleName,
      deletePeopleManagerships,
      deleteContentOwnerships,
    } = this.props;

    return (
      <AlertBox onDismiss={onDismiss}>
        <Heading>{t('settings.tab.roles.confirmation_modal.header')}</Heading>
        <SubHeading>
          <p>{t('settings.tab.roles.confirmation_modal.description')}</p>
          <ul className="ml-20">
            {deletePeopleManagerships && (
              <li>
                <p>
                  {t('settings.tab.roles.delete_managerships.from_text')}{' '}
                  <strong>
                    {t(
                      'settings.tab.roles.edit.people_management_labels.group_by_group_access',
                    )}
                  </strong>{' '}
                  {t('conjunctions.to')}{' '}
                  <strong>
                    {permissionsToGrant.has('manage_all')
                      ? t(
                          'settings.tab.roles.edit.people_management_labels.full_access',
                        )
                      : t(
                          'settings.tab.roles.edit.people_management_labels.no_access',
                        )}
                  </strong>{' '}
                  {t('settings.tab.roles.confirmation_modal.which_will')}{' '}
                  <em>
                    {t('settings.tab.roles.delete_managerships.description')}
                  </em>{' '}
                  {t('settings.tab.roles.delete_managerships.description_2')}
                </p>
              </li>
            )}

            {deleteContentOwnerships && (
              <li>
                <p>
                  {t('settings.tab.roles.delete_content_ownerships.from_text')}{' '}
                  <strong>
                    {t(
                      'settings.tab.roles.edit.content_ownership_labels.item_by_item_access',
                    )}
                  </strong>{' '}
                  {t('conjunctions.to')}{' '}
                  <strong>
                    {permissionsToGrant.has('own_all')
                      ? t(
                          'settings.tab.roles.edit.content_ownership_labels.full_access',
                        )
                      : t(
                          'settings.tab.roles.edit.content_ownership_labels.no_access',
                        )}
                  </strong>{' '}
                  {t('settings.tab.roles.confirmation_modal.which_will')}{' '}
                  <em>
                    {t(
                      'settings.tab.roles.delete_content_ownerships.description',
                    )}
                  </em>{' '}
                  {t(
                    'settings.tab.roles.delete_content_ownerships.description_2',
                  )}
                </p>
              </li>
            )}
          </ul>

          <p>
            {deletePeopleManagerships && deleteContentOwnerships
              ? t('settings.tab.roles.confirmation_modal.call_to_action.plural')
              : t(
                  'settings.tab.roles.confirmation_modal.call_to_action.singular',
                )}{' '}
            <strong>{roleName}</strong>{' '}
            {t('settings.tab.roles.confirmation_modal.in_the_box')}
          </p>
        </SubHeading>
        <TypeToConfirm
          confirmationText={roleName}
          onConfirmationChange={confirmed => this.setState({ confirmed })}
          white
        />
        <ButtonGroup alignEnd>
          <LinkButton
            type="primary"
            className="cancel mr-24 ml-24"
            onClick={onDismiss}
          >
            {t('common.cancel')}
          </LinkButton>
          <Button onClick={onSubmit} primary disabled={!this.state.confirmed}>
            {t('settings.tab.roles.confirmation_modal.confirm_button_text')}
          </Button>
        </ButtonGroup>
      </AlertBox>
    );
  }
}

export default ConfirmationModal;
